import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskFinishUI = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskFinishUI;
